import * as React from 'react';

interface ISectionProps {
  children?: React.ReactNode;
  id: string;
  style?: React.CSSProperties;
}

const defaultProps: React.CSSProperties =  {
  paddingBottom: '2rem',
  paddingTop: '2rem',
};

export function Section(props: ISectionProps) {
  const { id, style, children } = props;

  // FIXME Adding a background image to the style object does nothing
  return (
    <div id={id} className="container" style={Object.assign({}, defaultProps, style)}>
      {children}
    </div>
  );
}
